import React from "react";
import { Home_WhyChooseUs_Data } from "../../Constant/Data";

const WhyChooseUs = () => {
  const data = Home_WhyChooseUs_Data;
  return (
    <>
      <section className="bg-gradient-primary-gradient height-300 d-flex flex-column  justify-content-center align-items-center">
        <h2 className="text-white text-center" data-aos="fade-in">
          Why Choose Us?
        </h2>
        <span className="text-white">
          {/* Lorem ipsum dolor sit amet, consectetur adipisicing. */}
        </span>
      </section>
      {/* Horizontal grid of 1 x 5 with gapx 4 and mt-n4 using bootstrap classs and use data */}
      <div className="container mt-n5">
        <div className="row justify-content-between">
          {data.map((items) => (
            <div className="col-md-2 col-6 mb-2" key={items.id}>
              <div
                className="max-width-200 height-200 d-flex flex-column justify-content-center align-items-center p-4 cursor-pointer card1 position-relative border-radius-xl why-choose-us-card"
                style={{
                  // bg-red
                  backgroundColor: "rgba(255, 255, 255, 0.5) !important",
                  boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)",
                }}
              >
                <h5 className="text-black text-center card-title">
                  {items.title}
                </h5>
                <img src={items.image} className={`icon-image w-50 h-50`}></img>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhyChooseUs;
